import * as React from 'react';
import { generateScale, getGenerator, shiftScale } from '../../modules/utils'

import { times } from 'lodash'  
import Fret from '../fret'

import { IChord, IScale } from '../../models'

const HIGHLIGTED_FRETS = [3, 5, 7, 9, 12, 15, 17, 19, 21]

interface IFretboardProps {
    readonly rootNote: string | null,
    readonly chord: IChord | null,
    readonly intervals: any, // TODO: fix
    readonly scale: IScale,
    readonly scaleKey: string,
    readonly tuningNotes: ReadonlyArray<string>
}

class Fretboard extends React.Component<IFretboardProps> {

    public render () {
        const tuningNotes = this.props.tuningNotes
        const {scale, scaleKey} = this.props;
        // tslint:disable-next-line
        console.log(this.props)

        return <div>
            <table className='fretboard'>
                <tbody>
                    {times(tuningNotes.length, (stringNumber) => {
                        const generator = getGenerator(tuningNotes[stringNumber])
                        const scaleNotes = generateScale(scaleKey, scale.skips)

                        return <tr>
                            {times(24, (fretNumber) => this.renderFret(generator, scaleNotes, stringNumber, fretNumber))}
                        </tr>
                    })}
                    <tr className='fretboard-marks'>
                        {times(24, (fretNumber) => {
                            return <td><span>{this.renderFretNumber(fretNumber)}</span></td>
                        })}
                    </tr>
                </tbody>
            </table>
        </div>
    }

    private renderNote (scale: ReadonlyArray<string>, note: string) {
        const scaleNotes = shiftScale(scale, this.props.rootNote)
    
        if (this.props.chord) {
          if (this.props.chord.formula.indexOf(scaleNotes.indexOf(note) + 1) > -1) {
            return <Fret active={true} scale={scaleNotes} note={note} />
          } else {
            return <Fret active={false} scale={scaleNotes} note={note} />
          }
        }
    
        if (this.props.intervals) {
          if (this.props.intervals[scaleNotes.indexOf(note) + 1]) {
            return <Fret active={true} scale={scaleNotes} note={note} />
          } else {
            return <Fret active={false} scale={scaleNotes} note={note} />
          }
        }
    
        if (scale.indexOf(note) > -1) {
          return <Fret active={true} scale={scaleNotes} note={note} />
        } else {
          return <Fret active={false} scale={scaleNotes} note={note} />
        }
      }
    
    private renderFret (
        generator: Generator, 
        scale: ReadonlyArray<string>, 
        stringNumber: number, 
        fretNumber: number
    ) 
    {
        const tuningNotes = this.props.tuningNotes
    
        if (fretNumber === 0) {
          return this.renderNote(scale, tuningNotes[stringNumber])
        } else {
          return this.renderNote(scale, generator.next().value)
        }
    }

    private renderFretNumber (fretNumber: number) {
        if (HIGHLIGTED_FRETS.indexOf(fretNumber) > -1) {
            return fretNumber === 12 ? '●●' : '●'
        } else {
            return null
        }
    }
}

export default Fretboard



// WEBPACK FOOTER //
// ./src/components/fretboard/index.tsx